<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">

      <!-- Brand logo-->
      <b-link class="brand-logo">
        <vuexy-logo />

        <h2 class="brand-text text-primary ml-1">
          PT. BIMA
        </h2>
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Hero -->
      <b-col lg="8" class="d-none d-lg-flex p-0 auth-hero-wrap">
        <section class="auth-hero-content w-100 h-100 d-flex flex-column justify-content-between">
          <div class="auth-hero-top d-flex align-items-center">
            <img
              src="/assets/logo-96.png"
              alt="Logo"
              class="mr-1"
              style="width: 56px"
            />
            <div>
              <h3 class="mb-0 text-white">PT. BIMA</h3>
              <small class="text-white-70">ERP System</small>
            </div>
          </div>
          <div class="auth-hero-main">
            <h1 class="auth-hero-title">
              Akses kembali akun Anda dengan aman.
            </h1>
            <p class="auth-hero-subtitle">
              Gunakan email terdaftar untuk proses pemulihan akun pada ERP BIMA.
            </p>
            <ul class="auth-hero-points mb-0">
              <li>Proteksi akun dan akses berbasis peran.</li>
              <li>Alur reset untuk menjaga keamanan operasional.</li>
              <li>Dukungan tim IT jika ada kendala autentikasi.</li>
            </ul>
          </div>
          <small class="text-white-70">
            ERP BIMA — Sistem terpadu untuk distribusi dan gudang.
          </small>
        </section>
      </b-col>
      <!-- /Left Text-->

      <!-- Forgot password-->
      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg px-2 p-lg-5"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >
          <b-card-title class="mb-1">
            Lupa Password? 🔒
          </b-card-title>
          <b-card-text class="mb-2">
            Masukan email kamu dan kami akan mengirim link untuk reset password
          </b-card-text>

          <!-- form -->
          <validation-observer ref="simpleRules">
            <b-form
              class="auth-forgot-password-form mt-2"
              @submit.prevent="validationForm"
            >
              <b-form-group
                label="Email"
                label-for="forgot-password-email"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Email"
                  rules="required|email"
                >
                  <b-form-input
                    id="forgot-password-email"
                    v-model="userEmail"
                    :state="errors.length > 0 ? false:null"
                    name="forgot-password-email"
                    placeholder="saya@bimeastindonesia.com"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <b-button
                type="submit"
                variant="primary"
                block
              >
                Kirim link
              </b-button>
            </b-form>
          </validation-observer>

          <p class="text-center mt-2">
            <b-link :to="{name:'auth-login'}">
              <feather-icon icon="ChevronLeftIcon" /> Kembali ke login
            </b-link>
          </p>
        </b-col>
      </b-col>
      <!-- /Forgot password-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow, BCol, BLink, BCardTitle, BCardText, BForm, BFormGroup, BFormInput, BButton,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BRow,
    BCol,
    BLink,
    BForm,
    BButton,
    BFormGroup,
    BFormInput,
    BCardTitle,
    BCardText,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      userEmail: '',
      // validation
      required,
      email,
    }
  },
  methods: {
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Link tidak akan dikirim, karena dalam proses pengembangan, sabat yaa :)',
              icon: 'EditIcon',
              variant: 'warning',
            },
          })
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';

.auth-wrapper.auth-v2 .auth-hero-wrap {
  min-height: 100vh;
  background-image: linear-gradient(
      135deg,
      rgba(255, 152, 1, 0.78),
      rgba(255, 152, 1, 0.55)
    ),
    url('/assets/realistic-bg.png');
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}

.auth-hero-content {
  padding: 2.5rem 3rem;
  color: #fff;
}

.auth-hero-title {
  color: #fff;
  font-size: 2.2rem;
  line-height: 1.2;
  margin-bottom: 1rem;
  font-weight: 700;
  max-width: 700px;
}

.auth-hero-subtitle {
  color: rgba(255, 255, 255, 0.92);
  font-size: 1rem;
  margin-bottom: 1rem;
  max-width: 700px;
}

.auth-hero-points {
  color: rgba(255, 255, 255, 0.95);
  padding-left: 1.1rem;
}

.auth-hero-points li {
  margin-bottom: 0.45rem;
}

.text-white-70 {
  color: rgba(255, 255, 255, 0.78);
}

.dark-layout .auth-wrapper.auth-v2 .auth-hero-wrap {
  background-image: linear-gradient(
      135deg,
      rgba(255, 152, 1, 0.72),
      rgba(255, 152, 1, 0.45)
    ),
    url('/assets/realistic-bg.png');
}
</style>
